import { Avatar, AvatarGroup } from '@sravni/react-design-system/lib/Avatar';
import { Space } from '@sravni/react-design-system/lib/Space';

import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

type TOrganizationLogosProps = {
  logos: string[];
  category?: string;
};

export const OrganizationLogos: FC<TOrganizationLogosProps> = ({ logos, category }) => {
  if (logos.length === 0) {
    return null;
  }

  if (logos.length === 1) {
    if (category === PRODUCT_TYPES_VALUES.CREDIT_CARD) {
      return (
        <img
          width={44}
          src={logos[0]}
          alt="Logo"
        />
      );
    }

    return (
      <Avatar
        size={44}
        src={logos[0]}
      />
    );
  }

  return (
    <Space>
      <AvatarGroup size={44}>
        {logos.map((logo) => (
          <Avatar
            key={logo}
            src={logo}
          />
        ))}
      </AvatarGroup>
    </Space>
  );
};
